import Vue from 'vue'
import Router from 'vue-router'
import main from '@/components/page/main.vue'
import login from '@/components/page/login.vue'
import mlogin from '@/components/page/h5/mlogin.vue'
import mdevice from '@/components/page/h5/mdevice.vue'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    // console.log('Router eorro', err);
  })
}

Vue.use(Router)

export default new Router({
  routes: [{
      path: "/login",
      name: "login",
      component: login
    },
    {
      path: "/mlogin",
      name: "mlogin",
      component: mlogin
    },
    {
      path: "/mdevice",
      name: "mdevice",
      component: mdevice
    },
    {
      path: "/leave",
      name: "leave",
      component: () => import('@/components/page/h5/leave.vue')
    },
    {
      path: "/",
      name: 'main',
      component: main,
      children: [{
          path: "device",
          name: 'device',
          component: () => import('@/components/page/device/device.vue')
        },

      ]
    },
    {
      path: "/seeClass",
      name: "seeClass",
      component: () => import('@/components/page/seeClass.vue')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js